import { createSlice } from "@reduxjs/toolkit";

export const sessionSlice = createSlice({
  name: "auth/session",
  initialState: {
    token: "",
    signedIn: false,
  },
  reducers: {
    onSignInSuccess: (state, { payload }) => {
      state.signedIn = true;
      state.token = payload;
    },
    onSetSignInSuccess: (state) => {
      state.signedIn = true;
    },
    onSignOutSuccess: (state) => {
      state.signedIn = false;
      state.token = "";
    },
    setToken: (state, { payload }) => {
      state.token = payload;
    },
  },
});

export const {
  onSignInSuccess,
  onSetSignInSuccess,
  onSignOutSuccess,
  setToken,
} = sessionSlice.actions;

export default sessionSlice.reducer;
